import { Components, Theme } from "@mui/material";

const MuiIconButton: Components<Theme>["MuiIconButton"] = {
  styleOverrides: {
    root: {
      width: "36px",
      height: "36px",
      borderRadius: "5px",
    },
  },
};

export default MuiIconButton;
